import { Button } from '@/components/shadcn/ui/button';
import { Command, CommandInput } from '@/components/shadcn/ui/command';
import { Table, TableCell, TableHead, TableHeader, TableRow } from '@/components/shadcn/ui/table';
import { PlusIcon,  Trash2Icon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useActivityTypeContext } from './ActivityTypeContext';
import { useActivityType } from '@/hook/useActivityType';
import React from 'react';
type FormValuesType = {
  type: {
    id: number | null,
    name: string,
  }[]
}

const ActivityType = () => {
  const { addActivityType } = useActivityTypeContext();
  const {activityTypes, searchedActivityType, deleteActivityType, saveActivityTypes, createActivityType, searchActivityType } = useActivityType();
  
  const [nextId, setNextId] = useState(0);
  const { register, formState: { errors }, handleSubmit, control } = useForm<FormValuesType>({
    // defaultValues: {
    //   type: [
    //     { id: 1, name: 'Almoço' },
    //     { id: 2, name: 'Apresentação' },
    //     { id: 3, name: 'Ligação' },
    //     { id: 4, name: 'Email' },
    //     { id: 5, name: 'Reunião' },
    //     { id: 6, name: 'Mensagem'}
    //   ]
    // }
  });

  const { fields, append, remove, replace } = useFieldArray({
    name: 'type',
    control, 
    rules: {
      required: 'Cadastre pelo menos 1 tipo de atividade'
    }
  });

  useEffect(() => {
    if(fields.length === 0){
      append(activityTypes.map((type) => ({
        id: type.id,
        name: type.name
      })).sort((a,b)=>a.id - b.id));
    }},[activityTypes]);

  const onSubmit = (data: FormValuesType) => {
    const activityTypes = data.type.map(type => ({
      id:type.id,
      name: type.name
    }));
    addActivityType(data.type);
    saveActivityTypes(activityTypes);
  };

  return (
    <div className='flex min-h-screen bg-indigo-200 p-8 justify-center'>
      <div className='min-h-100 w-[50%] flex flex-col items-center overflow bg-white rounded-md py-4 mx-8 mb-4'>
        
        <div className='flex m-2 px-8 w-full justify-between items-center'>
          <h1 className='text-md font-medium'>Tipos de Atividade</h1>
          <div className='flex gap-6 items-center'>
            <Button
              type='button'
              onClick={() => {
                append({
                  id: nextId,
                  name: ''
                });
                // setNextId(prevId => prevId + 1);
              }}
              variant='ghost' 
              className='gap-1 p-4 bg-indigo-50 hover:bg-indigo-200'> 
              <PlusIcon size={12}/> 
              Adicionar 
            </Button>
            <Command className='flex items-center rounded-lg border-2 p-1 gap-1'>
              <CommandInput onChangeCapture={(e) => { 
                const target = e.target as HTMLInputElement;
                if(target.value!=''){
                  searchActivityType(target.value);
                  replace(searchedActivityType.map((type) => ({
                    id: type.id,
                    name: type.name
                  })).sort((a, b) => a.id - b.id));
                } else if(target.value === '' || fields.length === 0){
                  replace(activityTypes);
                }    
              }} placeholder='Pesquisar'/>
            </Command>
          </div>
        </div>
        
        <div className='flex mx-4 my-4 py-2 w-[80%] m-4 border rounded-lg'>
          <form onSubmit={handleSubmit(onSubmit)} className='w-full'>

            <Table>
              <TableHeader>
                <TableHead>Descrição</TableHead>
                <TableHead >Ações</TableHead>
              </TableHeader>
              {fields.map((field, index) => (
                <TableRow className='border-b-0' key={field.id}>
                  <TableCell>
                    <input
                      className='w-full h-10 border rounded-lg p-2 focus:outline-none hover:bg-slate-50'
                      {...register(`type.${index}.name`)}
                    />
                  </TableCell>
                  <TableCell>
                    <button type='button' title='Apagar'>
                      <Trash2Icon
                        onClick={() => {
                          remove(index);
                          let idDelete = 0;
                          activityTypes.forEach((ab)=>{
                            if(field.name === ab.name){
                              idDelete =ab.id;
                            }
                          });
                          if(idDelete != 0){
                            deleteActivityType(idDelete);
                          }
                          
                        }}
                        size={26} 
                        className='bg-red-600 hover:bg-red-800 rounded-md p-1'/>
                    </button>  
                  </TableCell>
                </TableRow>
              ))}
            </Table>
            <Button
              type='submit'
              variant='ghost'
              className='mt-4 mx-4 p-4 bg-indigo-50 hover:bg-indigo-200' 
            >
              Salvar Alterações
            </Button>
          </form>
          <p>{errors.type?.message}</p>
        </div>
      </div>
    </div>
  );
};

export default ActivityType;
